import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {AutoplayStartUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayStartUIAct';
import {AutoplayEnableSpinAutoModeUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayEnableSpinAutoModeUIAct';

export class AutoplayStartUIState extends UIState {
    public static readonly ID = 'AutoplayStartUIState';

    public setAct(): void {
        this.act = sequence([
            AutoplayEnableSpinAutoModeUIAct,
            AutoplayStartUIAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.isAutoplay.value;
    }
}